
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import Form from 'element-ui/lib/form';

var script = {
  name: 'PendoForm',
  components: {
    ElForm: Form
  },
  props: {
    formRef: {
      type: String,
      required: true
    },
    formDefaults: {
      type: Object,
      required: true
    },
    callValidate: {
      type: Boolean,
      default: false
    },
    callResetFields: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: this.formDefaults
    };
  },

  updated() {
    this.$nextTick(function () {
      if (this.callValidate) {
        this.validateForm();
      }

      if (this.callResetFields) {
        this.resetFields();
      }
    });
  },

  methods: {
    validateForm() {
      const form = this.$refs[this.formRef];
      form.validate(valid => {
        if (valid) {
          this.$emit('formValidated', form.model);
        } else {
          this.$emit('invalidForm');
        }
      });
    },

    resetFields() {
      this.$refs[this.formRef].resetFields();
      this.$emit('fieldsReset');
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('el-form', {
    ref: _vm.formRef,
    staticClass: "pendo-form",
    attrs: {
      "model": _vm.form,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.validateForm();
      }
    }
  }, [_vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-form.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoForm = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoForm;
